import styled from 'styled-components';

export const LoadingStyled = styled.div`
  width: 100%;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};
  min-height: 100vh;
  height: 100%;
`;
